module.exports = __webpack_public_path__ + "img/milva-logo-green.0e9857f6.svg";